import {createNativeStackNavigator} from '@react-navigation/native-stack';
import React from 'react';
import HomeScreen from './HomeScreen';
import Profile from './profile';
import Notifications from './notifications';
import NewPost from './newPost';
import EditProfile from './editProfile';
import Search from './search';
import PostDetails from './postDetails';
import Communities from './Communities';
import CommunityDetails from './CommunityDetails';
import Announcements from './Announcements';
import ReportPost from './ReportPost';
import AdminReports from './AdminReports';
import Help from './Help';
import CreatePoll from './CreatePoll';
import PollsList from './PollsList';
import PollDetails from './PollDetails';
import SpinWheelsList from './SpinWheelsList';
import SpinWheelScreen from './SpinWheelScreen';
import Deals from './Deals';
//import ReelsScreen from './ReelsScreen';

const HomeStack = createNativeStackNavigator();

export default function HomeStackNavigator() {
  return (
    <HomeStack.Navigator
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
      }}>
      <HomeStack.Screen name="Home" component={HomeScreen} />
      <HomeStack.Screen name="profile" component={Profile} />
      <HomeStack.Screen name="notifications" component={Notifications} />
      <HomeStack.Screen name="newPost" component={NewPost} />
      <HomeStack.Screen name="editProfile" component={EditProfile} />
      <HomeStack.Screen name="search" component={Search} />
      <HomeStack.Screen name="postDetails" component={PostDetails} />
      <HomeStack.Screen name="Communities" component={Communities} />
      <HomeStack.Screen name="CommunityDetails" component={CommunityDetails} />
      <HomeStack.Screen name="Announcements" component={Announcements} />
      <HomeStack.Screen name="ReportPost" component={ReportPost} />
      <HomeStack.Screen name="AdminReports" component={AdminReports} />
      <HomeStack.Screen name="Help" component={Help} />
      <HomeStack.Screen name="CreatePoll" component={CreatePoll} />
      <HomeStack.Screen name="PollsList" component={PollsList} />
      <HomeStack.Screen name="PollDetails" component={PollDetails} />
      <HomeStack.Screen name="SpinWheelsList" component={SpinWheelsList} />
      <HomeStack.Screen name="SpinWheel" component={SpinWheelScreen} />
      <HomeStack.Screen name="Deals" component={Deals} />
    </HomeStack.Navigator>
  );
}
